import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  Description as DescriptionIcon,
  MenuBook as MenuBookIcon,
  PictureAsPdf as PictureAsPdfIcon,
} from '@mui/icons-material';
import { FULL_VERSION_CAPTION, GATED_DISABLED_ACCENT_SX } from './FullVersionTooltip';

/**
 * Factsheet / Brochure / Export Report row from the agent's
 * `TopViewingSitePlanDetail.tsx` — rendered between the project info
 * accordion and the Site Plan card. Disabled in the public app with an
 * inline caption below each label (agent `ListItemText.secondary` parity).
 */
const GATED_ACTIONS: ReadonlyArray<{ key: string; label: string; icon: React.ReactNode }> = [
  { key: 'factsheet', label: 'Factsheet', icon: <DescriptionIcon fontSize="small" /> },
  { key: 'brochure', label: 'Brochure', icon: <MenuBookIcon fontSize="small" /> },
  { key: 'export', label: 'Export Report', icon: <PictureAsPdfIcon fontSize="small" /> },
];

/** Agent accent outline — kept so disabled buttons match the enabled layout. */
const gatedButtonSx = {
  flex: 1,
  minWidth: 0,
  py: 1.25,
  px: 1,
  borderRadius: 1.5,
  flexDirection: 'column' as const,
  gap: 0.25,
  ...GATED_DISABLED_ACCENT_SX,
};

export const ProjectActionButtons: React.FC = () => (
  <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
    {GATED_ACTIONS.map((action) => (
      <Button
        key={action.key}
        variant="outlined"
        size="small"
        fullWidth
        disabled
        sx={gatedButtonSx}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            width: '100%',
          }}
        >
          {action.icon}
          <Typography component="span" variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {action.label}
          </Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.65rem',
            lineHeight: 1.2,
            color: 'rgba(var(--color-text-rgb), 0.65)',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {FULL_VERSION_CAPTION}
        </Typography>
      </Button>
    ))}
  </Box>
);

export default ProjectActionButtons;
